import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

interface TextAreaProps<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  label: string;
  placeholder?: string;
  error?: string;
  rows?: number;
}

export function TextArea<T extends FieldValues>({
  control,
  name,
  label,
  placeholder,
  error,
  rows = 4,
}: TextAreaProps<T>) {
  return (
    <div className="space-y-3">
      <Label className="text-base font-semibold text-brand-dark">{label}</Label>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Textarea
            {...field}
            placeholder={placeholder}
            rows={rows}
            className={`rounded-lg border-slate-200 bg-transparent duration-200 ${error ? 'border-red-500 focus:border-red-500' : ''}`}
          />
        )}
      />
      {error && <p className="text-sm text-red-600 mt-2 font-medium">{error}</p>}
    </div>
  );
}